import React from 'react'

const MultipleUsers = ({ lightColor, darkColor, size }) => {
  const lightFill = lightColor ? lightColor : '#A0AEC0'
  const darkFill = darkColor ? darkColor : '#4A5568'
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M12 .75a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM15.75 14.25V12a3.75 3.75 0 0 0-7.5 0v2.25h1.5l.75 6h3l.75-6h1.5z"
          stroke={lightFill}
        />
        <path
          d="M4.5 3.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM5.7 9.947A3.754 3.754 0 0 0 .75 13.5v.75h1.5l.75 4.5h3l.376-2.256M19.5 3.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM18.3 9.947a3.754 3.754 0 0 1 4.95 3.553v.75h-1.5l-.75 4.5h-3l-.376-2.256M23.25 21c0 1.243-5.037 2.25-11.25 2.25S.75 22.243.75 21"
          stroke={darkFill}
        />
      </g>
    </svg>
  )
}

export default MultipleUsers
